import { LocalData } from "@src/to-be-removed/LocalData/General/LocalData";
import { PropertyCollectionItemData } from "../../../Property/Collections/PropertyCollectionItemData";
import { CustomFieldDataOptions } from "../../../Property/Collections/PropertyCustomFieldData";
import { CustomFieldDataTypeHelper, DataEditorContext } from "./CustomFieldDataTypeHelper";
import { getStringArray } from "@src/utils/arrayUtilities";

export class CustomFieldCollectionItemDataType extends CustomFieldDataTypeHelper<PropertyCollectionItemData> {
  getStringRepresentation(data: any, options: CustomFieldDataOptions, context: DataEditorContext): string | Promise<string> {
    if (!options.collectionID || !context.propertyID) return "";

    const collection = LocalData.properties.getData(context.propertyID)?.collections.addData(options.collectionID);
    if (!collection) return "";

    const ids = getStringArray(data);
    const items: PropertyCollectionItemData[] = ids.map((id) => collection.items.addData(id));

    if (items.some((data) => !data.loaded)) {
      return Promise.all(items.filter((item) => !item.loaded).map((item) => item.load()))
        .then(() => {
          return items.map((data) => data.name).join(", ");
        })
        .catch(() => {
          return items.map((data) => data.name).join(", ");
        });
    }

    return items.map((data) => data.name).join(", ");
  }
}
